import { render } from "./PredatorForm.vue?vue&type=template&id=21df19b0"
import script from "./PredatorForm.vue?vue&type=script&lang=js"
export * from "./PredatorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__